// SubscriptionExpiredPage.jsx
import React from 'react';

const SubscriptionExpiredPage = () => {
    const containerStyle = {
        minHeight: '100vh',
        background: "linear-gradient(to bottom, #76abff, #ffffff)",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '1rem',
        textAlign: 'center',
    };

    const cardStyle = {
        backgroundColor: '#FFFFFF',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        borderRadius: '16px',
        padding: '2.5rem',
        maxWidth: '400px',
        width: '100%',
    };

    const titleStyle = {
        fontSize: '2rem',
        fontWeight: 'bold',
        color: '#E53E3E',
        marginBottom: '1rem',
    };

    const textStyle = {
        color: '#4A5568',
        marginBottom: '1.5rem',
    };

    const buttonStyle = {
        backgroundColor: '#E53E3E',
        color: '#FFFFFF',
        padding: '0.75rem 1.5rem',
        borderRadius: '12px',
        border: 'none',
        cursor: 'pointer',
        fontSize: '1rem',
    };

    const handleRenew = () => {
        alert("Redirect to payment page or show modal here.");
    };

    return (
        <div style={containerStyle}>
            <div style={cardStyle}>
                <h1 style={titleStyle}>Subscription Expired</h1>
                <p style={textStyle}>
                Your subscription has expired. Please renew your plan to continue enjoying our services.
                </p>
                <button style={buttonStyle} onClick={handleRenew}>
                Check portal
                </button>
            </div>
        </div>
    );
};

export default SubscriptionExpiredPage;
